<template>
  <div class="hello">
    <div class="content">
      <div class="table_head flex">
        <div>{{detail.year}}年丨{{detail.score}}分丨{{detail.enroll_type}}丨{{detail.batch_name}}</div>
        <div>
          <button @click="save">保存志愿</button>
          <button @click="shenhe">审核志愿</button>
        </div>
      </div>
      <div class="table_main" v-for="(item,index) in data" :key='index'>
        <div class="table_one flex">
          <p class="index">
            <span class="rate" v-show="item.rate">{{item.rate}}%</span>
            <span class="rate" v-show="item.rate==0">-</span>
            志愿{{index+1}}
          </p>
          <p class="code">
            <input type="number" placeholder="请输入院校代码" v-model="item.enroll_code"
              @click="schoolCode(item,index,$event)">
          </p>
          <p class="name">
            {{item.school_name}}
          </p>
        </div>
        <div class="table_one major flex" v-for="(item1,index1) in item.major" :key=index1>
          <p class="index">
            <span class="rate" style="color:#C10B17 ;" v-show="item1.rate!=0&&item1.rate!=null">{{item1.rate}}%</span>
            <span class="rate" style="color:#C10B17 ;" v-show="item1.rate==0">-</span>
            <span> 专业{{index1+1}}</span>
          </p>
          <p class="code" @click="majorCode(item,index,index1)">
            <input type="number" v-model="item1.major_code" placeholder="请输入专业代码">
          </p>
          <p class="name">
            <span v-if=item1.major_name>{{item1.major_name}}({{item1.major_detail}})</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 搜索学校-->
    <el-dialog title="选择院校" :visible.sync="dialogTableVisible" width="700px">
      <div class="tabchange">
        <span :class="current==0?'active':''" @click="handleClick(0)">学校代码搜索</span>
        <span :class="current==1?'active':''" @click="handleClick(1)">学校名搜索</span>
      </div>
      <div style="width: 547px;margin: 0 auto;">
        <el-input :placeholder="placeholder" v-model="keyword">
          <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
        </el-input>
      </div>
      <el-table :data="gridData" style="width: 547px;margin: 0 auto;">
        <el-table-column property="school_name" label="学校名称"></el-table-column>
        <!--  <el-table-column property="batch_name" label="批次"></el-table-column> -->
        <el-table-column property="examinee_type" label="类别"></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAdd(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
        style="margin-top: 60px;" @current-change="current_change" v-if="pageshow">
      </el-pagination>
    </el-dialog>

    <!-- 搜索专业-->
    <el-dialog title="搜索专业" :visible.sync="dialogTableVisible1" width="800px">
      <div class="tabchange">
        <span :class="current1==0?'active':''" @click="handleClick1(0)">专业代码搜索</span>
        <span :class="current1==1?'active':''" @click="handleClick1(1)">专业名搜索</span>
      </div>
      <div style="width: 700px;margin: 0 auto;">
        <el-input :placeholder="placeholder1" v-model="major_keyword">
          <el-button slot="append" icon="el-icon-search" @click="searchMajor()">搜索</el-button>
        </el-input>
      </div>
      <el-table :data="majorData" style="width: 700px;margin: 0 auto;">
        <el-table-column property="major_name" label="专业名称"></el-table-column>
        <!--  <el-table-column property="batch_name" label="批次"></el-table-column> -->
        <el-table-column property="major_detail" label="详情" width="500px"></el-table-column>
        <el-table-column label="操作" width="80px">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAddMajor(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total1" :current-page.sync="page1"
        style="margin-top: 60px;" @current-change="current_change1" v-if="pageshow1">
      </el-pagination>
    </el-dialog>
  </div>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageshow: true,
        pageshow1: true,
        page: 1,
        page1: 1,
        total: 0,
        total1: 0,
        data: [{}, {}, {}, {}, {}, {}],
        majorData: [],
        keyword: '',
        dialogTableVisible: false,
        dialogTableVisible1: false,
        gridData: [],
        schoolNo: 0,
        majorNo: 1,
        id: '',
        major_keyword: '',
        school_id: '',
        detail: '',
        current: 0,
        current1: 0,
        placeholder: '请输入院校代码',
        placeholder1: '请输入专业代码'
      }
    },
    created() {
      this.id = this.$route.query.id
      this.getDetail()
    },
    methods: {
      current_change(e) {
        this.page = e
        this.search()
      },
      current_change1(e) {
        this.page1 = e
        this.searchMajor()
      },
      shenhe() {
        console.log(this.data)
        this.$http.intentionCheck({
          intention_id: this.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('审核完成!')
            this.getDetail()
          }

        })
      },
      handleClick(index) {
        if (index == 0) {
          this.placeholder = '请输入院校代码'
        } else {
          this.placeholder = '请输入院校名'
        }
        this.current = index

      },
      handleClick1(index) {
        if (index == 0) {
          this.placeholder1 = '请输入专业代码'
        } else {
          this.placeholder1 = '请输入专业名'
        }
        this.current1 = index

      },
      /* 弹出选择专业*/
      majorCode(item, index, index1) {
        console.log(item)
        this.school_id = item.a_school_id
        this.dialogTableVisible1 = true
        this.schoolNo = index
        this.majorNo = index1
        console.log(item, index, index1)
      },
      //* 选中专业 */
      handleAddMajor(row) {
        this.$http.inventionMajorAdd({
          id: this.id,
          a_school_id: row.a_school_id,
          pos: this.majorNo + 1,
          a_enroll_plan_id: row.id
        }).then(res => {
          this.$message.success('添加成功')
          console.log(this.schoolNo, this.majorNo)
          // this.data[this.schoolNo].major[this.majorNo] = row

          console.log(this.data[this.schoolNo].major[this.majorNo])
          this.data[this.schoolNo].major[this.majorNo] = JSON.parse(JSON.stringify(row));
          this.dialogTableVisible1 = false
          this.major_keyword = ''
          this.majorData = []
          this.getDetail()
        })
      },
      /* 选择学校*/
      handleAdd(row) {
        console.log(row)
        this.$http.inventionSchoolAdd({
          id: this.id,
          a_school_id: row.id,
          pos: this.schoolNo
        }).then(res => {
          this.$message.success('添加成功')
          this.data[this.schoolNo - 1].school_name = row.school_name
          this.data[this.schoolNo - 1].enroll_code = this.keyword
          this.data[this.schoolNo - 1].school_id = row.id
          this.dialogTableVisible = false
          this.gridData = []
          this.keyword = ''
          this.getDetail()
        })
      },
      getDetail() {
        this.$http.customCheckDetail({
          id: this.$route.query.id
        }).then(res => {
          this.detail = res.data
          let data1 = new Array(res.data.max_school_num).fill({})
          let major = new Array(res.data.max_major_num).fill({})
          for (let i = 0; i < res.data.max_school_num; i++) {
            data1[i] = {
              enroll_code: '',
              school_name: '',
              a_school_id: '',
              code: '',
              major: new Array(res.data.max_major_num).fill({}),
              rate: null
            }
            // this.data[i].major = major
          }
          this.data = data1
          console.log(this.data)
          for (let i = 0; i < res.data.detail.length; i++) {
            if (res.data.detail[i].position) {
              this.data[res.data.detail[i].position - 1].enroll_code = res.data.detail[i].enroll_code
              this.data[res.data.detail[i].position - 1].school_name = res.data.detail[i].school_name
              this.data[res.data.detail[i].position - 1].a_school_id = res.data.detail[i].algorithm_school_id
              this.data[res.data.detail[i].position - 1].rate = res.data.detail[i].rate
              // if (res.data.detail[i].major.length == res.data.max_major_num) {
              //   this.data[i].major = res.data.detail[i].major
              // }
              for (let o = 0; o < res.data.detail[i].major.length; o++) {
                if (res.data.detail[i].major[o].position) {
                  console.log(res.data.detail[i].position)
                  this.data[res.data.detail[i].position - 1].major[res.data.detail[i].major[o].position - 1] = res
                    .data
                    .detail[i].major[o]
                }
              }
            }
          }
        })
      },
      save() {
        this.$message.success('保存成功')
        this.$router.push('/artificialList?type=self')
      },
      searchMajor() {
        this.$http.customMajorSearchByCode({
          a_school_id: this.school_id,
          major_code: this.major_keyword,
          type: this.current1 == 0 ? 'code' : 'name',
        }).then(res => {
          this.majorData = res.data.list
          this.total1 = res.data.count
        })
      },
      search() {
        console.log(this.current)
        this.$http.customSchoolSearchByCode({
          school_code: this.keyword,
          intention_id: this.id,
          type: this.current == 0 ? 'code' : 'name',
          per: 10,
          page: this.page
        }).then(res => {
          this.gridData = res.data.list
          this.total = res.data.count
        })
      },
      schoolCode(item, index, event) {
        this.dialogTableVisible = true
        this.schoolNo = index + 1
        // if (event.currentTarget.value.length == 4) {
        //   item.enroll_code = event.currentTarget.value
        // }
      }
    }
  }
</script>

<style scoped lang="scss">
  .tabchange {
    text-align: center;
    font-size: 15px;
    margin-bottom: 20px;

    span {
      display: inline-block;
      width: 180px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      cursor: pointer;
    }

    .active {
      font-size: 18px;
      background: #C10B17;
      color: #ffffff;
      border-radius: 40px;
    }
  }

  .content {
    font-size: 14px;

    .table_one {
      min-height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #e7e4e4;

      input {
        border: none;
        outline: none;
        text-indent: 2em;
      }
    }

    .index {
      border-right: 1px solid #e7e4e4;
      color: #C10B17;
      font-size: 16px;
      font-weight: bold;

      span {
        display: inline-block;
        margin-right: 10px;
      }

      .rate {
        width: 40%;
      }


    }

    .code {}

    .major {
      .index {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }

    .table_main {
      width: 100%;
    }

    .index {
      flex: 1
    }

    .code {
      flex: 1
    }

    .name {
      flex: 5;
      min-height: 50px;
      text-align: left;
      padding-left: 20px;
      border-left: 1px solid #e7e4e4;
    }

    .table_head {
      width: 100%;
      justify-content: space-between;
      height: 61px;
      background: #C10B17;
      border-radius: 10px;
      color: #FFFFFF;

      button {
        width: 115px;
        height: 33px;
        border: 1px solid #FFFFFF;
        border-radius: 6px;
        background: #C10B17;
        color: #FFFFFF;
      }

      &>div {
        margin: 0 20px;
      }
    }

    width: 1200px;
    margin: 20px auto;
    // height: 932px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/volunteer/independent.vue